'use client'

import React, { useMemo } from 'react'
import { darkTheme, MeetingManager, MeetingProvider } from 'amazon-chime-sdk-component-library-react'
import { ConsoleLogger } from 'amazon-chime-sdk-js'
import { ThemeProvider as ScThemeProvider } from 'styled-components'

type ChimeProviderProps = React.PropsWithChildren<{}>

export function ChimeProvider(props: ChimeProviderProps) {
  const { children } = props

  const meetingManager = useMemo(() => new MeetingManager(new ConsoleLogger('ChimeProviderLogger')), [])

  return (
    <MeetingProvider meetingManager={meetingManager}>
      <ScThemeProvider theme={darkTheme}>{children}</ScThemeProvider>
    </MeetingProvider>
  )
}
